module.exports = __webpack_public_path__ + "img/logo.52575c9f.png";